import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React, { useCallback } from 'react';
import { situations, activitySectors, matrimonialRegimes } from 'utils/formData';
import { texts } from 'utils/languages/fr';
import {
    MemoizedActivitySectorsSelect,
    MemoizedMatrimonialRegimeSelect,
    MemoizedSituationsSelect,
    MemoizedTextField,
} from '../memoized-components/MemoizedComponents';

const useStyles = makeStyles(theme => ({
    field: { width: '100%', maxWidth: theme.constants.tunnelInputWidth },
}));

const SituationFprmFCPRPP = ({ situation, onChange, errors, tunnelErrors }) => {
    const classes = useStyles();

    const handleChange = useCallback(
        e => {
            const name = e.target.name;
            const value = e.target.value;
            onChange(name, value);
        },
        [onChange]
    );

    if (!situation) {
        return null;
    }

    return (
        <React.Fragment>
            <Typography variant="h6" gutterBottom>
                {texts.SITUATION_PERSONNELLE}
            </Typography>

            <MemoizedSituationsSelect
                name="situation"
                inputStyle={classes.field}
                value={situation.situation}
                onChange={handleChange}
                error={errors.situation}
                selected={situations[2].name}
            />

            {situation.situation === situations[0].name && (
                <MemoizedMatrimonialRegimeSelect
                    label={texts.REGIME_MATRIMONIAL}
                    name="matrimonialRegime"
                    inputStyle={classes.field}
                    value={situation.matrimonialRegime}
                    onChange={handleChange}
                    error={errors.matrimonialRegime}
                    selected={matrimonialRegimes[0].name}
                />
            )}

            <MemoizedTextField
                type="number"
                name="noOfPersons"
                inputStyle={classes.field}
                label={texts.NOMBRE_DE_PERSONNES_A_CHARGE}
                value={situation.noOfPersons}
                onChange={handleChange}
                error={errors.noOfPersons || tunnelErrors.numberOfDependents}
                showError={!tunnelErrors.numberOfDependents && !errors.noOfPersons}
            />

            <MemoizedTextField
                name="profession"
                inputStyle={classes.field}
                label={texts.PROFESSION}
                value={situation.profession}
                onChange={handleChange}
                error={errors.profession || tunnelErrors.jobTitle}
                showError={!tunnelErrors.jobTitle}
            />

            <MemoizedActivitySectorsSelect
                label={texts.ACTIVITY_SECTOR}
                name="activitySector"
                inputStyle={classes.field}
                value={situation.activitySector}
                onChange={handleChange}
                error={errors.activitySector}
                selected={activitySectors[0].name}
            />
        </React.Fragment>
    );
};

export default SituationFprmFCPRPP;
